import { PaymentTimeline } from "@/components/marketplace"
import type { PaymentTimelineSection } from "@/features/feed/contract"
import { SectionFrame } from "@/features/feed/sections/SectionFrame"
import type { FeedSectionProps } from "@/features/feed/sections/types"

export const PaymentTimelineFeedSection = ({ section, context }: FeedSectionProps<PaymentTimelineSection>) => {
  const { installmentAmount, installments, intervalDays, label, body, productName } = section.data
  if (installmentAmount == null) return null
  return (
    <SectionFrame section={section} context={context} gut>
      <PaymentTimeline installmentAmount={Number(installmentAmount)} installments={installments} intervalDays={intervalDays} label={label} body={body} productName={productName} />
    </SectionFrame>
  )
}
